import { FaCheck, FaMinus, FaTimes } from "react-icons/fa";

export function isUnset(value) {
  return value === undefined || value === null || value === "";
}

export function triBoolState(value) {
  if (value === true || value === "true") return "on";
  if (value === false || value === "false") return "off";
  return "unset";
}

const TRI_OPTIONS = [
  { id: "unset", label: "Nicht konfiguriert", title: "Nicht konfiguriert: schreibt den Schlüssel nicht ins Profil.", icon: FaMinus },
  { id: "on", label: "Aktiviert", title: "Aktiviert: schreibt den Schlüssel als true ins Profil.", icon: FaCheck },
  { id: "off", label: "Deaktiviert", title: "Deaktiviert: schreibt den Schlüssel als false ins Profil.", icon: FaTimes },
];

export default function TriStateControl({ value, onChange, disabled, name }) {
  const state = triBoolState(value);
  return (
    <div className={`profile-tri is-${state}`} role="group" aria-label={name || "Feldzustand"}>
      {TRI_OPTIONS.map((option) => {
        const Icon = option.icon;
        const active = state === option.id;
        return (
          <button
            key={option.id}
            type="button"
            className={`profile-tri-btn is-${option.id}${active ? " is-active" : ""}`}
            disabled={disabled}
            title={option.title}
            aria-label={option.label}
            aria-pressed={active}
            onClick={() => onChange(option.id === "unset" ? undefined : option.id === "on")}
          >
            <Icon aria-hidden="true" />
          </button>
        );
      })}
    </div>
  );
}
